// extracted by mini-css-extract-plugin
export default {"container":"style_container__iP7Js","shadow":"style_shadow__yWvP2","title":"style_title__GIf3o","userContainer":"style_userContainer__3ahvc","userImage":"style_userImage__ZYwCH"};